import React from 'react'

import { runAsOnClickHandler } from '@/utils'

type Pointer = [number, number]

type WheelZoom = (deltaY: number, pointer: Pointer) => void

// Apply accumulated movement once per frame, using the latest pointer position.
export const useWheelZoom = (onZoom: WheelZoom): WheelZoom => {
  const accDiff = React.useRef<number>(0)
  const frameIdRef = React.useRef<number | null>(null)
  const pointerRef = React.useRef<Pointer>([0, 0])

  React.useEffect(
    () => () => {
      if (frameIdRef.current !== null) {
        cancelAnimationFrame(frameIdRef.current)
      }
      frameIdRef.current = null
      accDiff.current = 0
    },
    []
  )

  return (deltaY, pointer) => {
    accDiff.current += deltaY
    pointerRef.current = pointer

    if (frameIdRef.current !== null) {
      return
    }

    frameIdRef.current = requestAnimationFrame(() => {
      const diff = accDiff.current
      accDiff.current = 0
      frameIdRef.current = null

      if (diff !== 0) {
        // todo: OCT-2456
        runAsOnClickHandler(() => onZoom(diff, pointerRef.current))
      }
    })
  }
}
